import { useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField
} from "@mui/material";
import { apiUrl } from "../../apiBase";

export default function ObjectivesSection({
  objectives,
  setObjectives,
  objectivesErrors,
  setObjectivesErrors,
  selectedEmployee,
  currentPeriod
}) {
  // 🔄 Traer objetivos del backend cuando cambia el legajo o el período
  useEffect(() => {
    const fetchObjectives = async () => {
      if (!selectedEmployee || !currentPeriod) return;

      try {
        const response = await fetch(
          apiUrl(`/api/objetivos?legajo=${selectedEmployee.legajo}&periodo=${encodeURIComponent(currentPeriod)}`)
        );
        const data = await response.json();
        setObjectives((Array.isArray(data) ? data : []).map((obj) => ({
          ...obj,
          achievement: obj.achievement ?? "",
          comment: obj.comment ?? "",
        })));
      } catch (error) {
        console.error("❌ Error al obtener objetivos previos:", error);
      }
    };

    fetchObjectives();
  }, [selectedEmployee, currentPeriod, setObjectives]);

  if (!objectives.length) return null;

  const handleObjectiveChange = (index, field, value) => {
    const updatedObjectives = [...objectives];

    // Validación del campo "achievement"
    if (field === "achievement") {
      let numericValue = parseInt(value, 10);
      if (isNaN(numericValue)) numericValue = 0;
      if (numericValue < 0) numericValue = 0;
      if (numericValue > 100) numericValue = 100;
      updatedObjectives[index][field] = numericValue;
    } else {
      updatedObjectives[index][field] = value;
    }

    setObjectives(updatedObjectives);

    // ✅ Si el objetivo tenía error y ahora lo completaron, sacar de errores
    if (objectivesErrors.includes(index)) {
      const obj = updatedObjectives[index];
      if (obj.achievement !== "" && String(obj.comment ?? "").trim() !== "") {
        const updatedErrors = objectivesErrors.filter((i) => i !== index);
        setObjectivesErrors(updatedErrors);
      }
    }
  };

  return (
    <Box mb={4}>
      <Typography variant="h6" gutterBottom>
        Objetivos Anteriores
      </Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Objetivo</TableCell>
              <TableCell align="center">% Cumplimiento</TableCell>
              <TableCell>Comentarios</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {objectives.map((obj, index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor: objectivesErrors.includes(index) ? "#ffebee" : "inherit"
                }}
              >
                <TableCell sx={{ fontSize: "0.9rem", verticalAlign: "top" }}>
                  {obj.description}
                </TableCell>
                <TableCell align="center">
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <TextField
                      type="number"
                      value={obj.achievement !== undefined ? obj.achievement : ""}
                      onChange={(e) => handleObjectiveChange(index, "achievement", e.target.value)}
                      inputProps={{ min: 0, max: 100 }}
                      size="small"
                      sx={{ width: "80px" }}
                      error={objectivesErrors.includes(index)}
                    />
                  </Box>
                </TableCell>
                <TableCell>
                  <TextField
                    value={obj.comment !== undefined ? obj.comment : ""}
                    onChange={(e) => handleObjectiveChange(index, "comment", e.target.value)}
                    multiline
                    minRows={2}
                    fullWidth
                    size="small"
                    error={objectivesErrors.includes(index)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
